export const NS = createNS('TEAMS');

import { createTypes, asyncType, createNS } from '@/utils/actionCreator';

export const ActionTypes = createTypes([...asyncType('TEAMS_GET')], NS);

export default ActionTypes;
